<template>
  <div>
    <component v-if="validUpdate" :is="compName" class="update-content"/>
    <h1 v-else>The "{{$route.params.id}}" update doesn't exist yet!</h1>
  </div>
</template>

<script>
import U_0 from '../updates/U_0';
import U_1 from '../updates/U_1';
import U_2 from '../updates/U_2';
import U_3 from '../updates/U_3';
import U_4 from '../updates/U_4';
import U_5 from '../updates/U_5';
import U_6 from '../updates/U_6';
import U_7 from '../updates/U_7';
import U_8 from '../updates/U_8';
import U_9 from '../updates/U_9';
import U_10 from '../updates/U_10';
import U_11 from '../updates/U_11';
import U_12 from '../updates/U_12';

export default {
  name: 'update',
  components: {
    U_0, U_1, U_2, U_3, U_4, U_5, U_6, U_7, U_8, U_9, U_10, U_11, U_12
  },
  data() {
    return {

    };
  },
  computed: {
    compName() {
      return `U_${this.$route.params.id}`;
    },
    validUpdate() {
      return this.$options.components[this.compName] != null;
    }
  }
};
</script>

<style>
.update-content {
  margin: 25px 20% 0 20%;
  text-align: center;
}

@media only screen and (max-width: 729px) {
  .update-content {
    margin: 25px 5px 0 5px;
    text-align: center;
  }
}

/* For child content */
.spacer {
  margin-top: 45px;
}
.div-after {
  margin-bottom: 5px;
}
.body-1 {
  margin-bottom: 15px;
  text-align: left;
}
.font-weight-medium {
  margin-bottom: 25px;
}
.u-image {
  max-width: 400px;
  margin: auto;
}
.u-image-large {
  max-width: 1200px;
  margin: auto;
}
.u-d-image {
  max-height: 75vh;
  width: auto;
  margin: auto;
}
</style>